import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const BackupManagerButton: LoadableType<{
	pathname: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ButtonsBackupManagerButton" */ '../src/Buttons/BackupManagerButton.tsx'
			)
		).BackupManagerButton,
});
